<template>
  <div class="hero-caroucel">
    <client-only>
      <carousel
        :items="1"
        :URLhashListener="true"
        :loop="true"
        :nav="false"
        :autoplayTimeout="7000"
        :autoplay="true"
        :autoplayHoverPause="true"
      >
        <slot></slot>
      </carousel>
    </client-only>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.hero-caroucel {
  height: 460px;

  @include av-mq(lap-and-up) {
    height: 708px;
  }

  .owl-dots {
    position: absolute;
    bottom: 1.5rem;
    width: 100%;
    .owl-dot {
      span {
        width: 50px;
        height: 4px;
        background-color: #f8f9fa !important;
        border-radius: 0;
        opacity: 0.3;
      }

      &.active {
        span {
          opacity: 1 !important;
        }
      }
    }
  }
}
</style>
